import type { SpringOptions, Transition, Variants } from "motion/react";

/** Standard durations (seconds) from the design spec. */
export const DURATION = { fast: 0.15, base: 0.25, slow: 0.4 } as const;

/** Signature ease, same curve as AnimateIn and --ease-signature. */
export const EASE_SIGNATURE = [0.16, 1, 0.3, 1] as const;

/** Spring for drags, dials, and toggles. */
export const SPRING_CONTROL: Transition = { type: "spring", stiffness: 300, damping: 26 };

/**
 * SpringOptions for useSpring() on animated numeric values (e.g. AnimatedNumber).
 * NOT a Transition: do not spread into a `transition` prop (it has no `type: "spring"`).
 */
export const SPRING_VALUE = { stiffness: 120, damping: 20 } as const satisfies SpringOptions;

/** Press feedback for any interactive tile/button. */
export const PRESS = { scale: 0.97 } as const;

/** Staggered entrance for tile grids (parent + child variants). */
export const STAGGER_PARENT: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.04, delayChildren: 0.05 } },
};

/** Child variant for STAGGER_PARENT grids; must share the hidden/show variant names. */
export const STAGGER_CHILD: Variants = {
  hidden: { opacity: 0, y: 12 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION.base, ease: EASE_SIGNATURE },
  },
};
